export class TokenError extends Error {
  constructor(message: string, error?: any) {
    super(message);
    this.name = 'CSS Auth';
    this.innerError = error;

    Object.setPrototypeOf(this, TokenError.prototype);
  }

  innerError?: any;
}
